const state = {
  BASE_URL: process.env.VUE_APP_API_URL,

  token: 'token',
  organizationWithUser: 'organizations/with-user',
  organizationInvitationWithUser: 'organizations/invitation/with-user',
  confirmEmail: 'accounts/confirm-email',
  requestPasswordReset: 'accounts/request-password-reset',
  resetPassword: 'accounts/reset-password',
  organizations: 'organizations',
  acceptInvitation: 'organizations/invitation',
  timezones: 'timezones',
  requestConfirmPhoneNumber: 'accounts/request-confirm-phonenumber',
  confirmPhoneNumber: 'accounts/confirm-phonenumber',
  loginThirdParty: 'token/third-party',
  loginApple: 'token/apple',
  acceptInvitationThirdParty: 'organizations/invitation/third-party',
  acceptInvitationApple: 'organizations/invitation/apple',
};
const getters = {
  getUrl: (state) => (name) => {
    return state[name];
  },
  circles: () => (organizationID, circleID = null) => {
    return 'organizations/' + organizationID + '/circles/' + (circleID ? circleID : '');
  },
  circleUsers: () => (organizationID, circleID) => {
    return 'organizations/' + organizationID + '/circles/' + circleID + '/users';
  },
  circleUser: () => (circleID, userID = null) => {
    return 'circles/' + circleID + '/users/' + (userID ? userID : '');
  },
  circle: () => (circleID) => {
    return '/circles/' + circleID;
  },
  invitation: () => (organizationID) => {
    return 'organizations/' + organizationID + '/invitation/';
  },
  invitationInformation: () => (token) => {
    return 'organizations/invitation/' + token;
  },
  getOrganizationUsers: () => (organizationID, userID = null) => {
    return 'organizations/' + organizationID + '/users/' + (userID ? userID : '');
  },
  updateUserRoleInCircle: () => (circleID, userID) => {
    return 'circles/' + circleID + '/users/' + userID + '/role';
  },
  updateUserNotificationInCircle: () => (circleID, userID) => {
    return 'circles/' + circleID + '/users/' + userID + '/notification';
  },
  getUsersCircles: () => (organizationID, userID) => {
    return 'organizations/' + organizationID + '/users/' + userID + '/circles';
  },
  notifications: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/notifications';
  },
  userNotifications: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + rootGetters.getUserId + '/notifications';
  },
  userAlerts: (state, a_, b_, rootGetters) => (userID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID + '/alerts';
  },
  zoneAlerts: (state, a_, b_, rootGetters) => (zoneID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/zones/' + zoneID + '/alerts';
  },
  circleAlerts: (state, a_, b_, rootGetters) => (circleID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/circles/' + circleID + '/alerts';
  },
  organizationAlerts: (state, a_, b_, rootGetters)  => {
    return 'organizations/' + rootGetters.getOrganizationId + '/alerts/';
  },
  alertRecipients: (state, a_, b_, rootGetters) => (userID, alertID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID + '/alerts/' + alertID + '/recipients';
  },
  notificationRecipients: (state, a_, b_, rootGetters) => (notificationID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/notifications/' + notificationID + '/recipients';
  },
  organizationLocations: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/locations';
  },
  zoneLocations: (state, a_, b_, rootGetters) => (zoneID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/zones/' + zoneID + '/locations';
  },
  userLocations: (state, a_, b_, rootGetters) => (userID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID + '/locations';
  },
  account: () => (userID = false) => {
    return 'accounts/' + (userID ? userID : '');
  },
  accountPassword: () => (userID) => {
    return 'accounts/' + userID + '/password';
  },
  organization: () => (organizationID = '') => {
    return 'organizations/' + organizationID;
  },
  channelConfiguration: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/channelconfigurations';
  },
  zones: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/zones/';
  },
  zone: () => (zoneID) => {
    return 'zones/' + zoneID;
  },
  zoneUsers: (state, a_, b_, rootGetters) => (zoneID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/zones/' + zoneID + '/users';
  },
  zonesMonitoredUsers: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/zones/users/monitored';
  },
  geofence: () => (zoneID) => {
    return 'zones/' + zoneID + '/geofence';
  },
  resendInvitation: (state, a_, b_, rootGetters) => (userID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID + '/invitation';
  },
  organizationUserRole: (state, a_, b_, rootGetters) => (userID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID + '/role';
  },
  organizationUser: (state, a_, b_, rootGetters) => (userID) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/users/' + userID;
  },
  subscriptionDetails: () => (subscriptionID) => {
    return 'organizations/' + subscriptionID + '/subscription/';
  },
  scheduledAlerts: () => (userID) => {
    return 'users/' + userID + '/scheduledalerts/';
  },
  unreadNotifications: (state, a_, b_, rootGetters)  => {
    return 'organizations/' + rootGetters.getOrganizationId + '/notifications/new';
  },
  unreadAlerts: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/alerts/new';
  },
  readAlert: (state, a_, b_, rootGetters) => alertID => {
    return 'organizations/' + rootGetters.getOrganizationId + '/alerts/' + alertID;
  },
  readNotification: (state, a_, b_, rootGetters) => notificationID => {
    return 'organizations/' + rootGetters.getOrganizationId + '/notifications/' + notificationID;
  },
  readMultipleAlerts: (state, a_, b_, rootGetters) => {
    return 'organizations/' + rootGetters.getOrganizationId + '/alerts/';
  },
};
export default {
  state,
  getters,
};